import { createHook, createStore, StoreActionApi } from "react-sweet-state"
import { Club, ClubDefaults } from "../entity"
import { LoadingStateDefaults } from "components/state/loadingstate"
import { load } from "components/state/loader"
import { Container } from "components/state/types"
import { EndpointResponse } from "components/http/endpoint"
import { NoEntityError, updateByEntityResponse } from "components/validation/validatableentity"
import { EntityState } from "components/state/entity"
import { apiGetClub } from "../endpoint"


interface State extends EntityState<Club> {
}

const StateDefaults: State = {
    ...LoadingStateDefaults,
    entity: ClubDefaults,
    errors: { ...NoEntityError },
}


const loadClub = (id: number) =>
    (store: StoreActionApi<State>) => {

        let loader = () => apiGetClub(id);

        let stateProducer = (draft: State, _: Container, response: EndpointResponse): void => {
            updateByEntityResponse(draft, response);
        }

        load<State>(store, loader, stateProducer);
    };


const store = createStore({
    initialState: StateDefaults,
    actions: {
        loadClub,
    },
    name: "Club"
});

const useState = createHook(store);

export {
    StateDefaults as ClubStateDefaults,
    State as ClubState,
    useState as useClub,
}
